import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import { showSuccess, showError } from "../../../services/toast.service";

const Panel = ({ selectedSessions = [], onDeleteSelected, onClearSelection, onDuplicateSelected }) => {
  const handleDeleteSelected = async () => {
    if (!selectedSessions.length) return;
    
    try {
      await onDeleteSelected(selectedSessions);
      showSuccess(`${selectedSessions.length} session(s) supprimée(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des sessions');
      console.error(error);
    }
  };
  
  const handleDuplicateSelected = async () => {
    if (!selectedSessions.length) return;
    
    try {
      await onDuplicateSelected(selectedSessions);
      showSuccess(`${selectedSessions.length} session(s) dupliquée(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la duplication des sessions');
      console.error(error);
    }
  };

  // Ne pas afficher le panel s'il n'y a pas de sessions sélectionnées
  if (!selectedSessions.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedSessions.length} session{selectedSessions.length > 1 ? 's' : ''} sélectionnée{selectedSessions.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke", styles.button)} onClick={handleDuplicateSelected}>
          <Icon name="copy" size="24" />
          <span>Dupliquer</span>
        </button>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleDeleteSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
